export const Months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export enum ObjectTypeForExport {
  'Document' = 'Document',
  'Paragraph' = 'Paragraph',
  'TextRun' = 'TextRun',
}
